import { TSiteTemplate } from '../../types';
import { set } from 'lodash';
import { childrenMutationSchemas } from './childrenMutationSchemas';

export const templateMutationSchema = (template: TSiteTemplate) => {
  const children = childrenMutationSchemas(template.template);
  set(template, 'template', children);
  return template;
};
